import App from './App';
import CustomSlider from './CustomSlider';
import CustomPhotoSwipe from './CustomPhotoSwipe';
import Header from './Header';
import Submenu from './Submenu';
import AuthenticatedArea from './AuthenticatedArea';


export { App, CustomSlider, CustomPhotoSwipe, Header, Submenu, AuthenticatedArea };



// WEBPACK FOOTER //
// ./src/components/index.js